import styled from 'styled-components'

interface IMainContainerStyledProps {}

export const MainContainerStyled = styled.div<IMainContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
